import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { AdaptiveLayoutFlag, AdaptiveLayoutProvider, AdaptiveLayoutService } from 'packages/sports/web/app/src/layout/adaptive-layout.service';
import { Observable, distinctUntilKeyChanged, map } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { quickBetStateSelector } from '../quick-bet.selectors';
import { IQuickBetState, QuickBetUiState } from '../quick-bet.state';

@Injectable()
export class QuickBetLayoutProvider implements AdaptiveLayoutProvider {
    private quickBetState$: Observable<IQuickBetState>;

    constructor(
        private store: Store<IBetslipRootState>,
        private adaptiveLayoutService: AdaptiveLayoutService,
    ) {}

    init(): void {
        this.quickBetState$ = this.store.select(quickBetStateSelector);
        this.adaptiveLayoutService.register(this);
    }

    asObservable(): Observable<AdaptiveLayoutFlag> {
        return this.quickBetState$.pipe(
            distinctUntilKeyChanged('uiState'),
            map((quickBetState) => {
                return {
                    quickBetActive: quickBetState.uiState !== QuickBetUiState.None,
                };
            }),
        );
    }
}
